<template>
  <div class="reg-select">
    <h3 style="text-align: left" v-if="state.response.transactionStatus == 'Approved'">Your payment was
      successful!</h3>
    <h3 style="text-align: left" v-else-if="state.response.transactionStatus == 'No Payment Required'">Your order
      was successful!</h3>
    <h3 style="text-align: left" v-else>Looks like there was an error with your order</h3>


    <div
        v-if="state.response.transactionStatus == 'Approved' || state.response.transactionStatus == 'No Payment Required'">
      <h5 class="header">Thank you for Registering for New Frontiers In Cosmetic Medicine 2026</h5> <br>
      <p>Thank you for registering for the <strong>New Frontiers in Cosmetic Medicine Symposium</strong> taking place on
        November 21-22, 2026 at the Hilton Hotel in Hasbrouck Heights, NJ. Get ready for a fabulous learning experience!
      </p>
      <p>Check your provided email for your order receipt and additional meeting information.</p>
    </div>
    <div v-else>
      <p>Your card was declined for the reason below:</p>
      <p>{{ state.response.details }}</p>

      <!--<button class="btn btn-default" @click="resetResponse">Go Back</button>-->
    </div>
    <iframe src="https://www.cosmeticfrontiers.com/api/2026/meeting/conversion.php" frameborder="0"
            style="display: none"></iframe>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Confirmation',
  mounted() {
    // This is our google event conversion snippet
    gtag('event', 'conversion', {
      'send_to': 'AW-17513251490/dkcJCLCdr5QbEKKF_J5B',
      'value': this.state.registrantData.total,
      'email': this.state.registrantData.attendeeEmail,
      'currency': 'USD',
      'transaction_id': ''
    })
  },
  computed: {
    ...mapGetters({
      state: 'getState',

    }),
  },
  methods: {
    resetResponse: function () {
      this.state.response = {};
    },
  },
}
</script>

<style scoped>
/* Confirmation container */
.reg-select {
  box-sizing: border-box;
  padding: 22px;

  background: linear-gradient(
      135deg,
      #e2f4f2 0%,
      #edf1fa 55%,
      #e6e4f5 100%
  );

  border: 1px solid #d5e1ea;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(49, 75, 111, 0.10);

  color: #535c98;
  font-family: inherit;
}

.reg-select * {
  box-sizing: border-box;
}

/* Payment or order status heading */
.reg-select > h3 {
  margin: 0 0 20px;
  padding: 18px 22px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-radius: 12px;

  color: #ffffff;
  font-family: inherit;
  font-weight: 300;
  line-height: 1.4;
  letter-spacing: 0.025em;
  overflow-wrap: anywhere;
}

/* Confirmation or error message panel */
.reg-select > div {
  padding: 24px;

  background: #ffffff;
  border: 1px solid #dfe6ee;
  border-radius: 11px;
}

/* Registration thank-you heading */
.reg-select .header {
  margin: 0;
  color: #535c98;

  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
}

/* Message text */
.reg-select p {
  margin: 0 0 18px;
  color: #535c98;

  font-family: inherit;
  font-weight: 400;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.reg-select strong {
  color: #535c98;
  font-weight: 600;
}

/* Receipt reminder or error details */
.reg-select > div > p:last-child {
  margin-bottom: 0;
  padding: 14px 16px;

  background: linear-gradient(
      135deg,
      #edf8f6 0%,
      #f0f1fa 100%
  );

  border: 1px solid #dfe6ee;
  border-radius: 9px;
}

/* Tablets and smaller devices */
@media (max-width: 767px) {
  .reg-select {
    padding: 16px;
    border-radius: 13px;
  }

  .reg-select > h3 {
    padding: 16px 18px;
    margin-bottom: 16px;
  }

  .reg-select > div {
    padding: 18px;
  }

  .reg-select .header {
    font-size: 16px;
    font-weight: 500;
  }
}

/* Phones */
@media (max-width: 480px) {
  .reg-select {
    padding: 12px;
  }

  .reg-select > h3 {
    padding: 14px 16px;
  }

  .reg-select > div {
    padding: 15px;
  }

  .reg-select .header {
    font-size: 15px;
  }

  .reg-select > div > p:last-child {
    padding: 12px;
  }
}
</style>
